import React from "react"
import Markdown from "@irati/ui/src/Markdown"
import GenericModal from "@irati/ui/src/GenericModal"
import Flex from "@irati/ui/src/Flex"
import {H2} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"
import icon1 from "./PointsBlendInfo.svg"
import icon2 from "./PointsBlendWallet.svg"

export function PointsBlendModal({shown, onClose}: {shown?: boolean; onClose: () => void}) {
  return (
    <GenericModal show={shown} onHide={onClose} hideActions>
      <Flex direction="column" gap={4}>
        <H2>
          <FormattedMessage id="platform.pointsBlend.modal.title" />
        </H2>
        <Flex gap={2}>
          <img src={icon1} alt="" />
          <Markdown source="platform.pointsBlend.modal.amounts" />
        </Flex>
        <Flex gap={2}>
          <img src={icon2} alt="" />
          <Markdown source="platform.pointsBlend.modal.spend" />
        </Flex>
        <Button primary full large onClick={onClose}>
          <FormattedMessage id="platform.wallet.TreatTokensModal.button.gotIt" />
        </Button>
      </Flex>
    </GenericModal>
  )
}
